module.exports = __webpack_public_path__ + "media/images/favicons/36x36-76bb15ae984569c8a771a18fad03e1cf.png";